// import { configureStore } from '@reduxjs/toolkit';
// import rootReducer from './reducer';

// const store = configureStore({
//     reducer: rootReducer,
//     middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware({
//             serializableCheck: false,
//         }),
// });

// export default store;

// src/redux/store.js

// import { createStore, applyMiddleware } from 'redux';
// import { thunk } from 'redux-thunk';
// import rootReducer from './reducer';

// // Load state from local storage
// const loadState = () => {
//     try {
//         const serializedState = localStorage.getItem('reduxState');
//         return serializedState ? JSON.parse(serializedState) : undefined;
//     } catch (err) {
//         console.error('Could not load state:', err);
//         return undefined;
//     }
// };

// // Save state to local storage
// const saveState = (state) => {
//     try {
//         const serializedState = JSON.stringify(state);
//         localStorage.setItem('reduxState', serializedState);
//     } catch (err) {
//         console.error('Could not save state:', err);
//     }
// };

// const persistedState = loadState();
// const store = createStore(rootReducer, persistedState, applyMiddleware(thunk));

// // Subscribe to store updates to save to local storage
// store.subscribe(() => {
//     saveState({
//         cache: store.getState().cache, // Only persist cache state
//     });
// });

// export default store;


import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducer';

// Load state from Cache Storage (if available)
const loadStateFromCache = async () => {
    try {
        const cache = await caches.open('redux-store-cache');
        const cachedResponse = await cache.match('reduxState');
        if (cachedResponse) {
            const cachedData = await cachedResponse.json();
            return cachedData;
        }
        return undefined;
    } catch (err) {
        console.error('Could not load state from cache:', err);
        return undefined;
    }
};

// Save state to Cache Storage
const saveStateToCache = async (state) => {
    try {
        const cache = await caches.open('redux-store-cache');
        const response = new Response(JSON.stringify(state));
        await cache.put('reduxState', response);
    } catch (err) {
        console.error('Could not save state to cache:', err);
    }
};

// Create the store
const persistedState = await loadStateFromCache(); // Load state asynchronously
const store = createStore(rootReducer, persistedState, applyMiddleware(thunk));

// Subscribe to store updates and save them to Cache Storage
store.subscribe(async () => {
    await saveStateToCache({
        cache: store.getState().cache, // Persist cache state
    });
});

export default store;

